/* Mint-ServiceGP-iPad (1180): ô lọc cao 44, 6 số tổng 3 cột, thẻ 2 cột. Màu chỉ var(--…). */
.page { gap: 12px; }
.seg button { height: 38px; font-size: 13px; }
.page :is(button[role='tab']) { height: 38px; font-size: 13px; }
.page label { height: 44px; border-radius: 10px; }
.page label :is(input, select) { font-size: 16px; }
.kpis { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.cards { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding-bottom: 88px; }
.card { width: 100%; display: flex; flex-direction: column; gap: 8px; padding: 14px 16px; box-sizing: border-box; border: 0; border-radius: 16px; background: var(--card); box-shadow: var(--sh); color: var(--tx); font: inherit; font-size: 15px; text-align: left; cursor: pointer; }
.card:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
.top { display: flex; align-items: center; gap: 10px; width: 100%; }
.tile { width: 38px; height: 34px; flex-shrink: 0; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 650; background: color-mix(in srgb, currentColor 13%, transparent); }
.av { width: 34px; height: 34px; flex-shrink: 0; border-radius: 50%; background: var(--pri-bg); color: var(--link); display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 600; }
.ttl { flex-grow: 1; min-width: 0; }
.ttl b { display: block; font-weight: var(--fw-label); }
.ttl > span { font-size: 13px; color: var(--lb); }
.gp { text-align: right; }
.gp b { display: block; font-size: 17px; font-weight: 600; }
.gp > span { font-size: 13px; color: var(--lb); }
.track { display: block; width: 100%; height: 6px; border-radius: 3px; background: var(--line); overflow: hidden; }
.track > span { display: block; height: 100%; }
.chips { display: flex; flex-wrap: wrap; gap: 4px 14px; font-size: 13px; }
.chips > span { display: inline-flex; align-items: center; gap: 4px; }
.chips > span:first-child { font-weight: var(--fw-label); }
